import * as yup from 'yup'

export default yup.object().shape({
  deadline_allows_modify_unit: yup.date().required('Campo requerido.')
})
